export type TInitialState = {
  // View program
  viewProgram: any;
  viewEvent: any;
};

export const initialState: TInitialState = {
  // View program
  viewProgram: {
    id: '',
    companyId: '',
    userId: '',
    title: '',
    startDate: '',
    endDate: '',
    stages: 0,
    programDetails: [],
    applicationForm: { sections: [] },
    status: 'Active',
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
    company: { id: '', email: '', name: '' }
  },
  viewEvent: {
    id: '',
    companyId: '',
    userId: '',
    title: '',
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    stages: 0,
    eventDetails: [],
    applicationForm: { sections: [] },
    status: 'Active',
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
    company: { id: '', email: '', name: '' }
  }
};
